import { getPlaceholder } from './usePlaceholders';
import { listPlaceholderRefs } from './usePlaceholderRefs';

const CSVColumnDelimiter = '__';

// Get valueCollection from DB
export const getTemplatePlaceholderFromRef = async (templateVersionId) => {
    const placeholderRefs = (await listPlaceholderRefs({
        isValid: true,
        templateVersionId: templateVersionId,
    })) || { items: [], totalCount: 0 };

    let placeholderGroups = {};
    for (let i in placeholderRefs.items) {
        const groupItem = await getPlaceholder(placeholderRefs.items[i].placeholderDefinitionId);
        placeholderGroups[groupItem.name] = [];
        groupItem.sample.map((item) => {
            placeholderGroups[groupItem.name].push(item);
        });
    }
    return placeholderGroups;
};

// Filter only used placeholders in groups
export const mapUsedPlaceholders = (usedPlaceholders, placeholderGroups) => {
    const newGroups = {};
    /* LAST WORKING
    Object.entries(placeholderGroups).map((group) => {
        newGroups[group[0]] = [];
        group[1].map((sample) => {
            const filteredPlaceholders = filterPlaceholderGroup(
                usedPlaceholders,
                group[0],
                sample,
            );

            if (Object.keys(filteredPlaceholders).length > 0) {
                newGroups[group[0]].push(filteredPlaceholders);
            }
        });
    }); */
    Object.entries(placeholderGroups).forEach(([groupKey, groupValue]) => {
        newGroups[groupKey] = [];
        groupValue.forEach((sample) => {
            const filteredPlaceholders = filterPlaceholderGroup(usedPlaceholders, groupKey, sample);
            if (Object.keys(filteredPlaceholders).length > 0) {
                newGroups[groupKey].push(filteredPlaceholders);
            }
        });
    });
    return newGroups;
};

// Filter one placeholder group data against templateDump usedPlaceholders
export const filterPlaceholderGroup = (usedPlaceholders, group, groupData) => {
    const newGroup = {};

    /* LAST WORKING
    Object.entries(groupData).map((placeholder) => {
        const search = findUsedPlaceholder(usedPlaceholders, group, placeholder[0]);

        if (search !== false) {
            newGroup[placeholder[0]] = placeholder[1];
        }
    }); */
    Object.entries(groupData).forEach(([key, value]) => {
        const search = findUsedPlaceholder(usedPlaceholders, group, key);
        if (search !== false) {
            newGroup[key] = value;
        }
    });
    return newGroup;
};

// find placeholder in templateDummp
export const findUsedPlaceholder = (usedPlaceholders, group, key) => {
    const search = usedPlaceholders.find((item) => item.group == group && item.ident == key);
    return typeof search === 'object' ? search : false;
};

// CSV flatten conversion
export const dumpCSV = (previewSampleData) => {
    const CSVMap = {
        type: 'common',
    };

    /* LAST WORKING
    Object.entries(previewSampleData).map((index) => {
        const key = index[0],
            value = index[1];
        if (typeof value === 'string') {
            CSVMap[createCSVColumnName([key])] = value;
        }
        if (typeof value === 'object') {
            for (let i in value) {
                if (key !== 'valueCollection') {
                    CSVMap[createCSVColumnName([key, i])] = value[i];
                } else {
                    for (let p in value[i][0]) {
                        CSVMap[createCSVColumnName([key, i, p])] = value[i][0][p];
                    }
                }
            }
        }
    }); */
    Object.entries(previewSampleData).forEach(([key, value]) => {
        if (typeof value === 'string') {
            CSVMap[createCSVColumnName([key])] = value;
        } else if (typeof value === 'object') {
            for (let i in value) {
                if (key !== 'valueCollection') {
                    CSVMap[createCSVColumnName([key, i])] = value[i];
                } else {
                    for (let p in value[i][0]) {
                        CSVMap[createCSVColumnName([key, i, p])] = value[i][0][p];
                    }
                }
            }
        }
    });
    return createCSVFile(CSVMap);
};

export const createCSVColumnName = (keyData) => {
    return keyData.join(CSVColumnDelimiter);
};

export const createCSVFile = (CSVMap) => {
    const header = Object.keys(CSVMap).join('";"');
    const row = Object.values(CSVMap).join('";"');
    return `"${header}"\n"${row}"`;
};

export const useTemplateSchema = async () => {
    return {
        getTemplatePlaceholderFromRef: getTemplatePlaceholderFromRef,
        //createFlatObject: createFlatObject,
        mapUsedPlaceholders: mapUsedPlaceholders,
        filterPlaceholderGroup: filterPlaceholderGroup,
        findUsedPlaceholder: findUsedPlaceholder,
        dumpCSV: dumpCSV,
        createCSVColumnName: createCSVColumnName,
        createCSVFile: createCSVFile,
    };
};

export default useTemplateSchema;
